import React, {useEffect, useState} from 'react';
import {useSearchParams} from "react-router-dom";

interface PaginationProps {
  totalItems: number;
  itemsPerPage: number;
}

export const Pagination: React.FC<PaginationProps> = ({
                                                        totalItems,
                                                        itemsPerPage,
                                                      }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const maxPageButtons = 5;
  const [searchParams, setSearchParams] = useSearchParams();
  const pageIndex = parseInt(searchParams.get("page") || "1", 10)

  const handlePageClick = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page || pageIndex);
      setSearchParams(new URLSearchParams({page: page.toString()}));
    }
  };

  useEffect(()=>{
    setCurrentPage(pageIndex);
    setSearchParams(new URLSearchParams({page: pageIndex.toString()}));
  },[pageIndex])

  const getPageNumbers = () => {
    const pages: number[] = [];
    const half = Math.floor(maxPageButtons / 2);
    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, currentPage + half);

    if (currentPage <= half) {
      end = Math.min(totalPages, maxPageButtons);
    } else if (currentPage + half >= totalPages) {
      start = Math.max(1, totalPages - maxPageButtons + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
      <nav aria-label="Page navigation" className="d-flex justify-content-center">
        <ul className="pagination">
          <li className={`page-item user-select-none ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
                className="page-link"
                onClick={() => handlePageClick(currentPage - 1)}
            >
              Oldingi
            </button>
          </li>
          {getPageNumbers().map((page) => (
              <li
                  key={page}
                  className={`page-item user-select-none ${currentPage === page ? 'active' : ''}`}
              >
                <button
                    className="page-link"
                    onClick={() => handlePageClick(page)}
                >
                  {page}
                </button>
              </li>
          ))}
          <li className={`page-item user-select-none ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
                className="page-link"
                onClick={() => handlePageClick(currentPage + 1)}
            >
              Keyingi
            </button>
          </li>
        </ul>
      </nav>
  );
};